'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hoursBefore.js
// module id = 683
// module chunks = 0